import { render, staticRenderFns } from "./nav_desktop.vue?vue&type=template&id=d78b5d9e&scoped=true&lang=pug&"
import script from "./nav_desktop.vue?vue&type=script&lang=js&"
export * from "./nav_desktop.vue?vue&type=script&lang=js&"
import style0 from "./nav_desktop.vue?vue&type=style&index=0&id=d78b5d9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78b5d9e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/Users/romzat/Sites/romza-web-2/components/Logo.vue').default})
